var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('ul',{staticClass:"icons clearfix"},_vm._l((_vm.icons),function(icon){return _c('li',{key:icon},[_c('svgIcon',{attrs:{"icon":icon}}),_c('p',[_vm._v(_vm._s(icon))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }